import { useEffect } from 'react';

const SCRIPT_SRC = 'https://inforges.activehosted.com/f/embed.php?id=101';

const ActiveCampaignForm = ({ open }) => {
  useEffect(() => {
    if (!open) return;

    // Remove any existing script to force a fresh render of the form
    const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.charset = 'utf-8';
    document.body.appendChild(script);

    return () => {
      const s = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
      if (s) s.remove();
    };
  }, [open]);

  return <div className="_form_101" style={{ minHeight: '200px', paddingTop: '8px' }} />;
};

export default ActiveCampaignForm;
